<template>
    <div class="kit-calculator">
		<b-row>
			<b-col>
				<h1>TERRA Rusticus Kit Cost Calculator <span style="color:yellow; font-size: 0.5em;">v5.4.0</span></h1>
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<span style="color:white;"><a href="https://terra.gg">Donate / Website <i class="fas fa-globe"></i></a> | <a href="https://discord.gg/TERRA">Discord <i class="fab fa-discord"></i></a> | <a href="https://docs.terra.gg">Docs / Info <i class="fas fa-book"></i></a></span>
				<hr style="border: #3e3e3e solid 0.5px;"/>
			</b-col>
		</b-row>
        <b-row>
            <b-col md="4">
                <h2>Cost: <span class="text-success">$ {{ totalCost }}</span></h2>
                <p v-if="totalCost > 0 && totalCost < 50" style="font-size: 15px" class="font-weight-bold text-danger">
                    We do not make kits for less than $50.
                </p>
                <p v-if="hasExploCD" style="font-size: 15px" class="font-weight-bold text-danger">
                    We do not make kits with explosives with sub-one-hour cooldowns.
                </p>
                <div>
                    <br>
                    <button class="btn btn-primary" @click="toggleHideNone" v-if="!hideNone">
                        Show only selected
                    </button>
                    <button class="btn btn-primary" @click="toggleHideNone" v-if="hideNone">
                        Show all
                    </button>
                </div>
            </b-col>
            <b-col md="2">
                <b-form-group label="Kit Code">
                    <span class="text-muted">Copy - Paste</span>
                    <b-input v-model="code"/>
                </b-form-group>
            </b-col>
            <b-col md="2">
                <b-form-group label="Sale %">
                    <span class="text-muted">% off (active sale)</span>
                    <b-select :options="saleOptions" v-model="form.sale" @change="updateCode"/>
                </b-form-group>
            </b-col>
            <b-col md="3">
                <b-form-group label="Kit Cooldown">
                    <span class="text-muted">Kit Cooldown Timer</span>
                    <b-select :options="cooldownOptions" v-model="form.cooldown" @change="updateCode"/>
                </b-form-group>
            </b-col>
        </b-row>
        <div class="items-area">
            <b-row>
                <b-col>
                    <section-items sec="Weapons" :sections="sections" @sub-add="subAdd($event)" @uc="updateCode"/>
                </b-col>
                <b-col>
                    <section-items sec="Attachments" :sections="sections"  @sub-add="subAdd($event)" @uc="updateCode"/>
                    <section-items sec="Ammo" :sections="sections"  @sub-add="subAdd($event)" @uc="updateCode"/>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <section-items sec="Attire" :sections="sections"  @sub-add="subAdd($event)" @uc="updateCode"/>
					<section-items sec="Meds" :sections="sections"  @sub-add="subAdd($event)" @uc="updateCode"/>
                </b-col>
                <b-col>
                    <section-items sec="Explosives" :sections="sections"  @sub-add="subAdd($event)" @uc="updateCode"/>
                    <section-items sec="Traps" :sections="sections"  @sub-add="subAdd($event)" @uc="updateCode"/>
                </b-col>
            </b-row>
            <b-row style="margin-bottom: 100px">
                <b-col>
                    <section-items sec="Resources" :sections="sections"  @sub-add="subAdd($event)" @uc="updateCode"/>
                </b-col>
                <b-col>
                    <section-items sec="Construction" :sections="sections" @sub-add="subAdd($event)" @uc="updateCode"/>
                </b-col>
            </b-row>
        </div>
		<b-row>
			<b-col>
				<hr style="border: #3e3e3e solid 0.5px;"/>
				<center>
					<span style="color:white; padding-bottom: 2em;">&copy; {{ currentYear }} - TERRA Gaming Network</span>
				</center>
			</b-col>
		</b-row>
    </div>
</template>

<script>
    import Vue from 'vue';
    import config from '../items-config';
    import SectionItems from '../components/SectionItems';

    export default {
        name: 'Home',
        components: {SectionItems},
        data() {
            return {
                hideNone: false,
                sections: config,
                form: {
                    cooldown: 4320,
                    sale: 0,
                },
                code: null,
                cooldownOptions: [
                    {value: 2880, text: 'Once per wipe (1 max use)'},
                    {value: 1440, text: 'Daily (3 max uses + 12hr CD)'},
                    {value: 720, text: '12 hours'},
                    {value: 360, text: '6 hours'},
                    {value: 240, text: '4 hours'},
					{value: 180, text: '3 hours'},
                    {value: 120, text: '2 hours'},
                    {value: 60, text: '1 hour'},
                    {value: 45, text: '45 minutes'},
                    {value: 30, text: '30 minutes'},
                    {value: 20, text: '20 minutes'},
                    {value: 15, text: '15 minutes'},
					{value: 10, text: '10 minutes'},
                    {value: 5, text: '5 minutes'}
                ],
                saleOptions: [
                    {value: 0, text: '0'},
                    {value: 5, text: '5'},
                    {value: 10, text: '10'},
                    {value: 15, text: '15'},
                    {value: 20, text: '20'},
                    {value: 25, text: '25'},
                    {value: 30, text: '30'},
                    {value: 35, text: '35'},
                    {value: 40, text: '40'},
                    {value: 45, text: '45'},
                    {value: 50, text: '50'},
                ],

            };
        },
        created() {
            for (const sKey in this.sections) {
                const section = this.sections[sKey];
                for (const iKey in section.items) {
                    if (section.items.hasOwnProperty(iKey)) {
                        Vue.set(this.sections[sKey]['items'][iKey], 'hidden', false);
                        Vue.set(this.sections[sKey]['items'][iKey], 'quantity', 0);
                    }
                }
            }
            if (this.$route.query.code) {
                this.code = this.$route.query.code;
            }
        },
        methods: {
            subAdd({ sk, ik,  m }) {
                let current = this.sections[sk]['items'][ik].quantity;
                if(!current) current = 0;
                if (m === 'sub') {
                    if(current === 0) return;
                    Vue.set(this.sections[sk]['items'][ik], 'quantity', current - 1);
                }
                if (m === 'add') {
                    Vue.set(this.sections[sk]['items'][ik], 'quantity', current + 1)
                }
                this.updateCode();
            },
            updateCode() {
                this.code = this.configurationCode;
            },
            toggleHideNone() {
                if (this.hideNone) {
                    this.hideNone = false;
                    for (const sKey in this.sections) {
                        for (const iKey in this.sections[sKey].items) {
                            this.sections[sKey]['items'][iKey]['hidden'] = false;
                        }
                    }
                } else {
                    this.hideNone = true;
                    for (const sKey in this.sections) {
                        for (const iKey in this.sections[sKey].items) {
                            const item = this.sections[sKey].items[iKey];
                            if (item.quantity <= 0) {
                                this.sections[sKey]['items'][iKey]['hidden'] = true;
                            }
                        }
                    }
                }
            }
        },
        computed: {
			currentYear() {
				const d = new Date();
				return d.getFullYear();
			},
            totalWeight() {
                let weight = 0;
                for (const s of this.sections) {
                    for (const i of s.items) {
                        if(!i.quantity) continue;
                        weight += (i.quantity * (i.weight * s.weight)) / 10000;
                    }
                }
                return weight;
            },
            totalCost() {
                const totalWeight = this.totalWeight;
                console.log(`total weight is ${totalWeight}`);
                const coolDownMinutes = this.form.cooldown;
                const percentOff = this.form.sale;
                const first = totalWeight * (10 / Math.pow(coolDownMinutes, 0.85));
                const second  =  (100 - percentOff) / 100;
                const total =  first * second;
                return total - (((total % 5) >= 2.5) ? (-(5 - (total % 5))) : (total % 5));
            },
            hasExploCD() {
                for (const s of this.sections) {
                    if (s.name == 'Explosives') {
                        for (const i of s.items) {
                            if (i.quantity > 0 && this.form.cooldown < 60) {
                                return true;
                            }    
                        }
                    }
                }
                return false;
            },
            configurationCode() {
                let data = {
                    form: this.form,
                    items: []
                };
                for (const s of this.sections) {
                    for (const i of s.items) {
                        if(!i.quantity) continue;
                        data.items.push({
                            n: i.name,
                            q: i.quantity
                        });
                    }
                }
                const code = btoa(JSON.stringify(data));
                this.$router.replace({name: 'Home', query: {code: code}});
                return code;
            },
        },
        watch: {
            code() {
                if (this.code !== this.configurationCode && (this.code.trim()) !== '') {
                    const baseDecoded = atob(this.code);
                    const decoded = JSON.parse(baseDecoded);
                    this.form = decoded.form;
                    for (const sKey in this.sections) {
                        const section = this.sections[sKey];
                        for (const iKey in section.items) {
                            const item = this.sections[sKey]['items'][iKey];
                            Vue.set(this.sections[sKey]['items'][iKey], 'quantity', 0)
                            for (const preItem of decoded.items) {
                                console.log(preItem.n, item.name);
                                if (preItem.n === item.name) {
                                    console.log(preItem.n, preItem.q);
                                    Vue.set(this.sections[sKey]['items'][iKey], 'quantity', preItem.q)
                                }
                            }
                        }
                    }
                }
            }
        }
    };
</script>

<style lang="scss">
    h5 {
        border-bottom: #3e3e3e solid .1px;
    }
    .kit-calculator {
        font-size: 14px;
    }
    .form-control {
        font-size: 13px !important;
        height: 25px !important;
    }
    .custom-select {
        font-size: 13px !important;
        height: 25px !important;
        padding-bottom: 2px !important;
    }
    .change-value-button {
        cursor: pointer;
        text-align: center;
        &:hover {
            color: #c40000;
        }
    }
    .row-item {
        &:hover {
            background-color: #2f2f2f;
        }
    }
    /*.items-area {*/
    /*    overflow: auto;*/
    /*    overflow-x: hidden;*/
    /*    height: 1000px;*/
    /*}*/
</style>
